@if (brand === 'prixtel') {
  <div class="tabs-area icon-tab">
    <nav class="pb-3">
      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
        <a
          href="#nav-list"
          (click)="setActiveTab('liste')"
          id="nav-list-tab"
          class="nav-item nav-link left-border-tab {{ listTab }}"
          data-toggle="tab"
          role="tab"
          aria-controls="nav-list"
          aria-selected="true">JE PARRAINE
        </a>
        <a
          href="#nav-management"
          (click)="setActiveTab('gestion')"
          id="nav-management-tab"
          class="nav-item nav-link left-border-tab right-border-tab {{ managementTab }}"
          data-toggle="tab"
          role="tab"
          aria-controls="nav-management"
          aria-selected="false">MES PARRAINAGES
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        id="nav-list"
        class="tab-pane fade show {{ listTab }}"
        role="tabpanel"
        aria-labelledby="nav-list-tab">
        <p class="title">À chaque nouveau filleul : <span>1 mois de forfait offert</span></p>
        <!-- ********************************* Customer is not eligible ***************************** -->
        @if (!selectedSponsorship) {
          <div>
            <p class="bold-text">Actuellement, votre compte n'est pas éligible au parrainage.</p>
            <p class="bold-text">Pour pouvoir parrainer :</p>
            <ul class="list-style">
              <li>Vous devez avoir une ligne active depuis plus de 2 mois, sans aucune résiliation prévue.</li>
              <li>Vous devez être à jour de vos paiements.</li>
            </ul>
            <p>Le parrainage est également limité à 3 filleuls par an.</p>
          </div>
        }
        <!-- ********************************* Customer is eligible ***************************** -->
        @if (selectedSponsorship) {
          <div>
            <h2>COMMENT ÇA FONCTIONNE ?</h2>
            <div class="sponsorship-content">
              <span>1</span><strong>Double-cliquez</strong> sur le message ci-dessous pour le copier et
              <strong>l'envoyer à tous vos proches</strong> (famille, amis, collègues, voisins...)
            </div>
            <div (click)="copyLinkContent($event)" id="link-content" class="link-source sponsorship-content">
              <p id="sticker" class="sticker" (click)="copyLinkContent($event)"></p>
              <div
                id="sponsorLink"
                class="source"
                (click)="copyLinkContent($event)"
                [innerHTML]="sanitizeContent()"
              ></div>
            </div>
            <div class="sponsorship-content">
              <span>2</span>Votre filleul utilise votre lien unique pour souscrire à un forfait Prixtel.
              Vous lui offrez un mois gratuit.
            </div>
            <div class="sponsorship-content">
              <span>3</span>Si votre filleul reste plus de 3 mois, vous bénéficiez d’un mois de forfait gratuit !
            </div>
          </div>
        }
        <div class="sponsorship-content">
          <a href="https://cdn.prixtel.com/sources/pxl/files/pdf/documentation/commun/cgu/197/parrainage_prixtel_01_2026.pdf"
          class="document" target="_blank">Conditions du parrainage Prixtel</a>
        </div>
      </div>
      <!-- *********************************  Sponsorship management ****************************** -->
      <div class="tab-pane fade show {{ managementTab }}" id="nav-management" role="tabpanel" aria-labelledby="nav-management-tab">
        <app-sponsorship-management></app-sponsorship-management>
      </div>
    </div>
  </div>
}

@if (brand === 'prixtel') {
  <app-frequently-questions [faq]="faqPageCode"></app-frequently-questions>
}
